import React, { useState, useEffect, useCallback } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import pocketbaseService from '../services/pocketbase';

const { FiPlus, FiTrash2, FiEdit3, FiCheck, FiZap, FiTerminal, FiCpu, FiRefreshCw, FiX } = FiIcons;

const ApiHub = () => {
  const [tokens, setTokens] = useState([]);
  const [loading, setLoading] = useState(true);
  const [copiedId, setCopiedId] = useState(null);
  const [modalMode, setModalMode] = useState(null);
  const [formData, setFormData] = useState({ id: null, name: '', token: '', active: true });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      console.log("Sincronizando API Hub...");
      const tks = await pocketbaseService.getGretaTokens();
      setTokens(tks || []);
    } catch (err) {
      console.error("Erro Hub:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadData();
  }, [loadData]);

  const generateToken = () => {
    const t = Array.from(crypto.getRandomValues(new Uint8Array(16))).map(b => b.toString(16).padStart(2, '0')).join('');
    setFormData(prev => ({ ...prev, token: t }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      await pocketbaseService.saveGretaToken(formData);
      setModalMode(null);
      setTimeout(() => loadData(), 500);
    } catch (e) {
      alert("Erro: " + e.message);
      setLoading(false);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <div className="flex justify-between items-center mb-12">
        <div>
          <h1 className="text-2xl font-black text-slate-900 uppercase tracking-tighter flex items-center italic">
            <SafeIcon icon={FiCpu} className="mr-3 text-indigo-600" /> API Hub
          </h1>
          <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest mt-1">Conectores de Automação</p>
        </div>
        <button 
          onClick={() => { setFormData({ name: '', token: '', active: true }); generateToken(); setModalMode('create'); }}
          className="bg-slate-900 text-white px-8 py-4 rounded-2xl font-black text-[10px] uppercase shadow-2xl"
        >
          Novo Agente
        </button>
      </div>

      <div className="grid gap-6">
        {tokens.length === 0 && !loading ? (
          <div className="bg-slate-50 border-2 border-dashed border-slate-200 rounded-[3rem] p-16 text-center">
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Nenhuma API em greta_tokens</p>
          </div>
        ) : tokens.map(t => (
          <div key={t.id} className="bg-white border border-slate-100 rounded-[2.5rem] p-8 shadow-sm hover:shadow-xl transition-all group relative">
            <div className="flex items-center justify-between mb-8">
              <div className="flex items-center space-x-5">
                <div className="p-5 bg-slate-900 text-white rounded-[1.5rem] shadow-lg">
                  <SafeIcon icon={FiTerminal} className="text-xl" />
                </div>
                <div>
                  <h3 className="text-sm font-black text-slate-900 uppercase">{t.name}</h3>
                  <span className="text-[8px] font-black text-emerald-500 uppercase tracking-widest">● Ativo</span>
                </div>
              </div>
              <div className="flex space-x-2">
                <button onClick={() => { setFormData(t); setModalMode('edit'); }} className="p-3 text-slate-300 hover:text-indigo-600"><SafeIcon icon={FiEdit3} /></button>
                <button onClick={async () => { if(confirm('Excluir?')) { await pocketbaseService.deleteGretaToken(t.id); loadData(); } }} className="p-3 text-slate-300 hover:text-red-500"><SafeIcon icon={FiTrash2} /></button>
              </div>
            </div>
            <div className="flex bg-slate-50 p-4 rounded-[2rem] gap-4">
              <div className="flex-1 truncate font-mono text-[10px] font-bold text-slate-500 bg-white px-5 py-4 rounded-2xl border border-slate-100">
                {t.token}
              </div>
              <button 
                onClick={() => { navigator.clipboard.writeText(t.token); setCopiedId(t.id); setTimeout(() => setCopiedId(null), 2000); }}
                className="bg-indigo-600 text-white px-8 py-4 rounded-2xl text-[10px] font-black uppercase shadow-xl"
              >
                {copiedId === t.id ? 'Copiado' : 'Copiar'}
              </button>
            </div>
          </div>
        ))}
      </div>

      {modalMode && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center p-6 bg-slate-900/60 backdrop-blur-md">
          <div className="bg-white rounded-[3rem] w-full max-w-lg p-10 shadow-2xl relative">
            <button onClick={() => setModalMode(null)} className="absolute top-8 right-8 text-slate-300"><SafeIcon icon={FiX} /></button>
            <h2 className="text-xl font-black text-slate-900 uppercase mb-8">Configurar Agente</h2>
            <form onSubmit={handleSubmit} className="space-y-6">
              <input 
                type="text" placeholder="Nome do Agente" value={formData.name} 
                onChange={e => setFormData({...formData, name: e.target.value})} 
                className="w-full p-5 bg-slate-50 rounded-2xl font-black text-[10px] uppercase outline-none focus:ring-2 ring-indigo-500" 
                required
              />
              <div className="flex space-x-2">
                <input type="text" value={formData.token} readOnly className="flex-1 p-5 bg-slate-50 rounded-2xl font-mono text-xs text-slate-400" />
                <button type="button" onClick={generateToken} className="p-5 bg-slate-900 text-white rounded-2xl"><SafeIcon icon={FiRefreshCw} /></button>
              </div>
              <button type="submit" disabled={loading} className="w-full bg-indigo-600 text-white py-5 rounded-2xl font-black text-[10px] uppercase">Salvar Agente</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default ApiHub;